<template>
  <v-chart
    class="v-chart"
    :options="options"
    :init-options="{}"
    autoresize />
</template>

<script>
import ECharts from '@/components/public/ECharts.vue'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
export default {
  name: 'StockChart',
  components: {
    'v-chart': ECharts
  },
  props: {
    xAxis: {
      type: Array,
      default() {
        return []
      }
    },
    series1: {
      type: Array,
      default() {
        return []
      }
    },
    series2: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {
    options() {
      return {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['期初库存数', '期末库存数']
        },
        xAxis: [
          {
            type: 'category',
            data: this.xAxis,
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              rotate: 45
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            axisLabel: {
              formatter: '{value}件'
            }
          }
        ],
        series: [
          {
            name: '期初库存数',
            type: 'bar',
            data: this.series1
          },
          {
            name: '期末库存数',
            type: 'bar',
            data: this.series2
          }
        ]
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-chart {
    height 300px!important
}
</style>
